export const generatedAvatarColors = [
  '#5AA8FF',
  '#FF8A80',
  '#72D6A3',
  '#FFC857',
  '#B388FF',
  '#4DD0E1',
  '#FF9F68',
  '#6FCF97',
  '#7AA7FF',
  '#F48FB1',
  '#64D8CB',
  '#FFD166',
  '#9FA8FF',
  '#FFB74D',
  '#81C784',
  '#CE93D8',
  '#4FC3F7',
  '#FFAB91',
  '#AED581',
  '#80CBC4',
  '#F06292',
  '#90CAF9',
  '#DCE775',
  '#A5D6A7',
  '#FFCC80',
  '#B0BEC5',
];

const FIRST_LATIN_LETTER_CODE = 'A'.charCodeAt(0);

export const getAvatarColor = ({ username }: { username?: string }): string => {
  if (!username) return generatedAvatarColors[0];
  const firstLetter = username
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .charAt(0)
    .toUpperCase();
  const alphabetIndex = firstLetter.charCodeAt(0) - FIRST_LATIN_LETTER_CODE;

  if (alphabetIndex >= 0 && alphabetIndex < generatedAvatarColors.length) {
    return generatedAvatarColors[alphabetIndex];
  }

  return generatedAvatarColors[0];
};

export const getInitials = ({ username }: { username?: string }): string => {
  if (!username) return '';
  const words = username.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  const firstInitial = words[0].charAt(0).toUpperCase();
  const lastInitial = words[words.length - 1].charAt(0).toUpperCase();
  return firstInitial + lastInitial;
};
